"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBAutonomousPositive = function SvgBAutonomousPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M51.903 20.483a2.107 2.107 0 01-2.107-2.107v-7.678C49.8 4.791 54.587.004 60.494 0h22.738c5.907.004 10.694 4.791 10.698 10.698v7.418a2.107 2.107 0 11-4.214 0v-7.418a6.49 6.49 0 00-6.484-6.483H60.494a6.49 6.49 0 00-6.483 6.483v7.678a2.107 2.107 0 01-2.108 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M18.67 107.192a2.107 2.107 0 01-2.106-2.107V18.762a2.107 2.107 0 014.214 0v86.323a2.107 2.107 0 01-2.107 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M134.538 120.461H9.132A9.132 9.132 0 010 111.33v-6.322a2.107 2.107 0 014.215 0v6.322a4.917 4.917 0 004.917 4.917h125.406a4.917 4.917 0 004.917-4.917V58.583a2.107 2.107 0 014.215 0v52.76a9.132 9.132 0 01-9.132 9.118zM141.548 50.576a2.107 2.107 0 01-2.107-2.108V25.772a4.917 4.917 0 00-4.917-4.917H34.42a2.107 2.107 0 110-4.214h100.118a9.132 9.132 0 019.132 9.131v22.696a2.107 2.107 0 01-2.122 2.108z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M35.333 120.461a2.107 2.107 0 01-2.108-2.107V58.562a2.107 2.107 0 114.215 0v59.792a2.107 2.107 0 01-2.107 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M2.107 97.196A2.107 2.107 0 010 95.09V25.772a9.132 9.132 0 019.132-9.131h22.927a5.395 5.395 0 015.381 5.387v23.328a1.173 1.173 0 001.194 1.167H141.57a2.107 2.107 0 010 4.214H38.634a5.395 5.395 0 01-5.388-5.38V22.042c0-.646-.52-1.17-1.166-1.174H9.132a4.917 4.917 0 00-4.917 4.918v69.316a2.107 2.107 0 01-2.108 2.093z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M61.815 57.403a2.107 2.107 0 01-2.108-2.107V42.069a2.107 2.107 0 114.215 0v13.227a2.107 2.107 0 01-2.107 2.107zM114.947 57.403a2.107 2.107 0 01-2.107-2.107V42.069a2.107 2.107 0 114.214 0v13.227a2.107 2.107 0 01-2.107 2.107z",
    fill: "#285"
  })));
};

var _default = SvgBAutonomousPositive;
exports["default"] = _default;